// extracted by mini-css-extract-plugin
module.exports = {"fixed-footer":"fixed-footer--b8d2d3","fixedFooter":"fixed-footer--b8d2d3"};